// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__36otf","rootSuccess":"CompleteLink_rootSuccess__2bw4m","rootFailure":"CompleteLink_rootFailure__256yM","isDisabled":"CompleteLink_isDisabled__3414z"};